import React from "react";
import { Box, Grid, Paper, Stack, Typography, Chip, List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import { UsbOutlined, SaveOutlined, RestoreOutlined, CheckOutlined } from "@mui/icons-material";

const ATGCommanderSection = () => {
  return (
    <Box component="section" id="atg-commander" sx={{ py: 10 }}>
      <Grid container spacing={6} alignItems="center">
        <Grid item xs={12} md={6}>
          <Stack spacing={2}>
            <Typography variant="h1" sx={{ color: "#fff", fontWeight: 900, fontFamily: "Poppins, sans-serif" }}>
              ATG Commander
            </Typography>

            <Stack direction="row" spacing={1} flexWrap="wrap">
              <Chip label="USB Laptop Tool" icon={<UsbOutlined />} sx={{ color: "#fff" }} />
              <Chip label="Backup & Restore" icon={<SaveOutlined />} sx={{ color: "#fff" }} />
              <Chip label="Config Cloning" icon={<CheckOutlined />} sx={{ color: "#fff" }} />
            </Stack>

            <Typography variant="h3" sx={{ color: "rgba(226,232,240,0.8)", maxWidth: 560 }}>
              ATG Commander is desktop software for technicians. Connect to an ATG via USB,
              read the full tank + system configuration, save it to a file, and reflash it back later.
            </Typography>

            <Typography variant="body2" sx={{ color: "rgba(226,232,240,0.7)", maxWidth: 560 }}>
              Perfect for rollouts: standardize configurations across multiple sites and recover from mistakes instantly.
            </Typography>
          </Stack>
        </Grid>

        <Grid item xs={12} md={6}>
          <Paper
            elevation={10}
            sx={{
              borderRadius: 4,
              p: 3,
              bgcolor: "rgba(15,23,42,0.85)",
              border: "1px solid rgba(148,163,184,0.25)",
            }}
          >
            <Typography variant="h6" sx={{ color: "#fff", fontWeight: 800, mb: 1 }}>
              Key Capabilities
            </Typography>

            <List dense>
              <ListItem>
                <ListItemIcon><SaveOutlined sx={{ color: "rgba(226,232,240,0.85)" }} /></ListItemIcon>
                <ListItemText
                  primary="Save the full ATG configuration to a file"
                  primaryTypographyProps={{ sx: { color: "rgba(226,232,240,0.85)" } }}
                />
              </ListItem>

              <ListItem>
                <ListItemIcon><RestoreOutlined sx={{ color: "rgba(226,232,240,0.85)" }} /></ListItemIcon>
                <ListItemText
                  primary="Restore (reflash) configuration back to the ATG"
                  primaryTypographyProps={{ sx: { color: "rgba(226,232,240,0.85)" } }}
                />
              </ListItem>

              <ListItem>
                <ListItemIcon><CheckOutlined sx={{ color: "rgba(226,232,240,0.85)" }} /></ListItemIcon>
                <ListItemText
                  primary="Clone configs across stations to standardize setups"
                  primaryTypographyProps={{ sx: { color: "rgba(226,232,240,0.85)" } }}
                />
              </ListItem>
            </List>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ATGCommanderSection;
